




















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { firestore } from "firebase/app";
import DatePickerComponent from "@/components/common/DatePicker.vue";
import { CLIENT_TARGET_VERSION_FIELDS, ClientTargetVersionField } from "@/data/models/ClientAdministrationRow";
import { ClientSetupMaster, ClientSetupOptions, IOT_UPDATE_CONDITIONS } from "@/data/models/ClientSetup";
import { EMPTY_VALUE, targetAppBuildText } from "@/utils/ClientAdministrationDetail";
import { CONTRACT_TYPE_ORDER } from "@/utils/ClientContracts";
import { ClientSetupDraft, followsMaster } from "@/utils/ClientSetupDraft";
import {
  DEVICE_UPDATE_LABEL_KEYS,
  SummaryLine,
  contractLines,
  deviceUpdateLines,
  iotUpdateConditionText,
} from "@/utils/ClientSetupSummary";

type SinceField = "hasServiceContractForFirmwaresAndConfigsSince" | "hasWarrantyExtensionForPanelsSince";

@Component({
  components: { "date-picker": DatePickerComponent },
})
export default class SetupContractsStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: null }) options!: ClientSetupOptions | null;
  @Prop({ default: null }) master!: ClientSetupMaster | null;

  readonly contractTypes = CONTRACT_TYPE_ORDER;
  readonly deviceUpdateFields = DEVICE_UPDATE_LABEL_KEYS;
  readonly contracts: Array<{ flag: "hasServiceContractForFirmwaresAndConfigs" | "hasWarrantyExtensionForPanels"; since: SinceField; labelKey: string }> = [
    {
      flag: "hasServiceContractForFirmwaresAndConfigs",
      since: "hasServiceContractForFirmwaresAndConfigsSince",
      labelKey: "admin.clients.detail.fields.serviceContract",
    },
    {
      flag: "hasWarrantyExtensionForPanels",
      since: "hasWarrantyExtensionForPanelsSince",
      labelKey: "admin.clients.detail.fields.warrantyExtensionForPanels",
    },
  ];

  get member(): boolean {
    return followsMaster(this.draft);
  }

  get masterName(): string {
    return this.master?.name ?? EMPTY_VALUE;
  }

  /** The master's Verträge and update conditions; the targets always "as the MASTER-Mandant". */
  get masterLines(): SummaryLine[] {
    const t = (key: string, values?: unknown[]) => this.$t(key, values as never).toString();
    const follows = (labelKey: string): SummaryLine => ({ label: t(labelKey), value: t("admin.clients.setup.followsMaster") });
    return [
      ...(this.master?.contracts ? contractLines(this.master.contracts, t) : [follows("admin.clients.detail.sections.contracts")]),
      ...(this.master?.deviceUpdates ? deviceUpdateLines(this.master.deviceUpdates, t) : []),
      follows("admin.clients.detail.sections.targetVersions"),
    ];
  }

  get conditionItems() {
    const t = (key: string) => this.$t(key).toString();
    return IOT_UPDATE_CONDITIONS.map((value) => ({ value, label: iotUpdateConditionText(value, t) }));
  }

  /** The fleet's versions, as the detail's Zielversionen card shows a client's ("–" where none is set). */
  get fleetTargets(): Array<{ field: ClientTargetVersionField; value: string }> {
    const targets = this.options?.fleetTargets ?? {};
    return CLIENT_TARGET_VERSION_FIELDS.map((field) => ({
      field,
      value: field === "targetAppApk" ? targetAppBuildText(targets[field]) : targets[field] || EMPTY_VALUE,
    }));
  }

  /** The shared DatePicker works in Timestamps; the draft keeps epoch ms, as IRES Cloud takes them. */
  sinceTimestamp(field: SinceField): firestore.Timestamp | null {
    const millis = this.draft.contracts[field];
    return millis === null ? null : firestore.Timestamp.fromMillis(millis);
  }

  onSinceInput(field: SinceField, value: firestore.Timestamp | null) {
    this.draft.contracts[field] = value ? value.toMillis() : null;
  }
}
